import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  // Navigation
  'nav.home': { fr: 'Accueil', en: 'Home' },
  'nav.menu': { fr: 'Menu', en: 'Menu' },
  'nav.catering': { fr: 'Traiteur', en: 'Catering' },
  'nav.foodtruck': { fr: 'Camion Belgo', en: 'Food Truck' },
  'nav.gallery': { fr: 'Galerie', en: 'Gallery' },
  'nav.about': { fr: 'À propos', en: 'About' },
  'nav.contact': { fr: 'Contact', en: 'Contact' },
  'nav.cart': { fr: 'Panier', en: 'Cart' },
  'nav.admin': { fr: 'Admin', en: 'Admin' },
  'nav.order': { fr: 'Commander', en: 'Order Now' },

  // Hero
  'hero.subtitle': { fr: 'Restaurant | Traiteur | Camion', en: 'Restaurant | Catering | Food Truck' },
  'hero.tagline': { fr: 'La fesse de porc braisée 15 heures, notre spécialité depuis toujours.', en: '15-hour braised pork, our specialty since day one.' },
  'hero.cta': { fr: 'Voir le menu', en: 'View Menu' },
  'hero.cta2': { fr: 'Commander pour emporter', en: 'Order for Takeout' },

  // Menu
  'menu.title': { fr: 'Notre Menu', en: 'Our Menu' },
  'menu.subtitle': { fr: 'Des créations cochonnes avec des ingrédients de qualité', en: 'Bold pork creations with quality ingredients' },
  'menu.all': { fr: 'Tout', en: 'All' },
  'menu.poutines': { fr: 'Poutines', en: 'Poutines' },
  'menu.sandwichs': { fr: 'Sandwichs', en: 'Sandwiches' },
  'menu.accompagnements': { fr: 'Accompagnements', en: 'Sides' },
  'menu.desserts': { fr: 'Desserts', en: 'Desserts' },
  'menu.boissons': { fr: 'Boissons', en: 'Drinks' },
  'menu.addToCart': { fr: 'Ajouter au panier', en: 'Add to Cart' },
  'menu.featured': { fr: 'Vedette', en: 'Featured' },
  'menu.unavailable': { fr: 'Non disponible', en: 'Unavailable' },
  'menu.monthlySpecial': { fr: 'Spécial du mois', en: 'Monthly Special' },

  // Cart
  'cart.title': { fr: 'Votre panier', en: 'Your Cart' },
  'cart.empty': { fr: 'Votre panier est vide', en: 'Your cart is empty' },
  'cart.total': { fr: 'Total', en: 'Total' },
  'cart.subtotal': { fr: 'Sous-total', en: 'Subtotal' },
  'cart.taxes': { fr: 'Taxes (TPS+TVQ)', en: 'Taxes (GST+QST)' },
  'cart.checkout': { fr: 'Passer la commande', en: 'Proceed to Checkout' },
  'cart.remove': { fr: 'Retirer', en: 'Remove' },
  'cart.continueShopping': { fr: 'Continuer vos achats', en: 'Continue Shopping' },
  'cart.items': { fr: 'articles', en: 'items' },

  // Checkout
  'checkout.title': { fr: 'Commande pour emporter', en: 'Takeout Order' },
  'checkout.name': { fr: 'Nom complet', en: 'Full Name' },
  'checkout.email': { fr: 'Courriel', en: 'Email' },
  'checkout.phone': { fr: 'Téléphone', en: 'Phone' },
  'checkout.pickupTime': { fr: 'Heure de cueillette', en: 'Pickup Time' },
  'checkout.notes': { fr: 'Notes spéciales', en: 'Special Notes' },
  'checkout.placeOrder': { fr: 'Confirmer la commande', en: 'Place Order' },
  'checkout.processing': { fr: 'Traitement en cours...', en: 'Processing...' },
  'checkout.success': { fr: 'Commande confirmée!', en: 'Order Confirmed!' },
  'checkout.successMsg': { fr: 'Votre commande a été reçue. Vous recevrez une confirmation par courriel.', en: 'Your order has been received. You will receive a confirmation email.' },
  'checkout.orderNumber': { fr: 'Numéro de commande', en: 'Order Number' },
  'checkout.payment': { fr: 'Paiement', en: 'Payment' },
  'checkout.paymentNote': { fr: 'Paiement sécurisé par Élavon (en cours d\'intégration - paiement au comptoir)', en: 'Secure payment by Elavon (integration in progress - pay at counter)' },

  // Catering
  'catering.title': { fr: 'Traiteur Belgo', en: 'Belgo Catering' },
  'catering.subtitle': { fr: 'Des forfaits cochons pour vos événements', en: 'Bold pork packages for your events' },
  'catering.package1.name': { fr: 'Forfait Classique', en: 'Classic Package' },
  'catering.package1.desc': { fr: 'Poutine classique et cochon braisé pour 25+ personnes', en: 'Classic poutine and braised pork for 25+ guests' },
  'catering.package2.name': { fr: 'Forfait Cochon', en: 'Pork Package' },
  'catering.package2.desc': { fr: 'Menu complet cochon braisé avec accompagnements pour 50+ personnes', en: 'Full braised pork menu with sides for 50+ guests' },
  'catering.package3.name': { fr: 'Forfait Sur Mesure', en: 'Custom Package' },
  'catering.package3.desc': { fr: 'Menu personnalisé selon vos besoins et votre budget', en: 'Custom menu tailored to your needs and budget' },
  'catering.requestQuote': { fr: 'Demander une soumission', en: 'Request a Quote' },
  'catering.form.eventDate': { fr: 'Date de l\'événement', en: 'Event Date' },
  'catering.form.guestCount': { fr: 'Nombre d\'invités', en: 'Number of Guests' },
  'catering.form.eventType': { fr: 'Type d\'événement', en: 'Event Type' },
  'catering.form.message': { fr: 'Message / demandes spéciales', en: 'Message / Special Requests' },
  'catering.form.submit': { fr: 'Envoyer la demande', en: 'Submit Request' },
  'catering.form.success': { fr: 'Demande envoyée! Nous vous contacterons rapidement.', en: 'Request sent! We\'ll contact you soon.' },
  'catering.minOrder': { fr: 'Commande minimum de 25 personnes', en: 'Minimum order of 25 people' },

  // Food Truck
  'foodtruck.title': { fr: 'Camion Belgo', en: 'Belgo Food Truck' },
  'foodtruck.subtitle': { fr: 'Cuisine de rue urbaine pour vos événements', en: 'Urban street food for your events' },
  'foodtruck.schedule': { fr: 'Prochains emplacements', en: 'Upcoming Locations' },
  'foodtruck.noSchedule': { fr: 'Aucun événement à venir', en: 'No upcoming events' },
  'foodtruck.book': { fr: 'Réserver le camion', en: 'Book the Truck' },
  'foodtruck.bookDesc': { fr: 'Minimum de 50 personnes, certaines conditions s\'appliquent', en: 'Minimum 50 guests, conditions apply' },
  'foodtruck.form.date': { fr: 'Date souhaitée', en: 'Desired Date' },
  'foodtruck.form.time': { fr: 'Heure du service', en: 'Service Time' },
  'foodtruck.form.guests': { fr: 'Nombre d\'invités', en: 'Number of Guests' },
  'foodtruck.form.location': { fr: 'Lieu de l\'événement', en: 'Event Location' },
  'foodtruck.form.generator': { fr: 'Besoin d\'une génératrice?', en: 'Need a generator?' },
  'foodtruck.form.submit': { fr: 'Soumettre la demande', en: 'Submit Request' },

  // Gallery
  'gallery.title': { fr: 'Galerie', en: 'Gallery' },
  'gallery.subtitle': { fr: 'Découvrez nos créations et notre ambiance', en: 'Discover our creations and atmosphere' },
  'gallery.all': { fr: 'Toutes', en: 'All' },
  'gallery.plats': { fr: 'Plats', en: 'Dishes' },
  'gallery.restaurant': { fr: 'Restaurant', en: 'Restaurant' },
  'gallery.foodtruck': { fr: 'Camion', en: 'Truck' },
  'gallery.events': { fr: 'Événements', en: 'Events' },

  // About
  'about.title': { fr: 'Notre Histoire', en: 'Our Story' },
  'about.p1': { fr: 'Au Resto Belgo, nous travaillons la fesse de porc à la façon des grands-parents Bernard. La viande est cuite doucement pendant 15 heures, ce qui lui donne toute sa tendreté tout en conservant son aspect juteux.', en: 'At Resto Belgo, we prepare pork in the tradition of the Bernard grandparents. The meat is slow-cooked for 15 hours, giving it incredible tenderness while keeping it juicy.' },
  'about.p2': { fr: 'Notre toute nouvelle salle à manger vous accueille du mercredi au dimanche. Nous sommes heureux de vous présenter nos nouveautés telles que les Belgofres ainsi que nos mocktails colorés!', en: 'Our brand new dining room welcomes you from Wednesday to Sunday. We are happy to present our new items such as Belgofres and our colorful mocktails!' },
  'about.values.title': { fr: 'Nos Valeurs', en: 'Our Values' },
  'about.values.quality': { fr: 'Qualité', en: 'Quality' },
  'about.values.quality.desc': { fr: 'Ingrédients frais et locaux', en: 'Fresh and local ingredients' },
  'about.values.tradition': { fr: 'Tradition', en: 'Tradition' },
  'about.values.tradition.desc': { fr: 'Recettes familiales depuis des générations', en: 'Family recipes for generations' },
  'about.values.passion': { fr: 'Passion', en: 'Passion' },
  'about.values.passion.desc': { fr: 'L\'amour de la bonne bouffe', en: 'Love of good food' },

  // Contact
  'contact.title': { fr: 'Contactez-nous', en: 'Contact Us' },
  'contact.address': { fr: '153 Champlain, Saint-Jean-sur-Richelieu, QC', en: '153 Champlain, Saint-Jean-sur-Richelieu, QC' },
  'contact.phone': { fr: '+1 (450) 347-8635', en: '+1 (450) 347-8635' },
  'contact.hours': { fr: 'Heures d\'ouverture', en: 'Opening Hours' },
  'contact.form.subject': { fr: 'Sujet', en: 'Subject' },
  'contact.form.message': { fr: 'Message', en: 'Message' },
  'contact.form.send': { fr: 'Envoyer', en: 'Send' },
  'contact.form.success': { fr: 'Message envoyé! Merci.', en: 'Message sent! Thank you.' },

  // Footer
  'footer.followUs': { fr: 'Suivez-nous', en: 'Follow Us' },
  'footer.rights': { fr: 'Tous droits réservés.', en: 'All rights reserved.' },
  'footer.quickLinks': { fr: 'Liens rapides', en: 'Quick Links' },

  // Admin
  'admin.title': { fr: 'Tableau de bord', en: 'Dashboard' },
  'admin.login': { fr: 'Connexion Admin', en: 'Admin Login' },
  'admin.email': { fr: 'Courriel', en: 'Email' },
  'admin.password': { fr: 'Mot de passe', en: 'Password' },
  'admin.signIn': { fr: 'Se connecter', en: 'Sign In' },
  'admin.logout': { fr: 'Déconnexion', en: 'Logout' },
  'admin.menu': { fr: 'Menu', en: 'Menu' },
  'admin.orders': { fr: 'Commandes', en: 'Orders' },
  'admin.catering': { fr: 'Traiteur', en: 'Catering' },
  'admin.foodtruck': { fr: 'Camion', en: 'Truck' },
  'admin.gallery': { fr: 'Galerie', en: 'Gallery' },
  'admin.messages': { fr: 'Messages', en: 'Messages' },
  'admin.stats': { fr: 'Statistiques', en: 'Statistics' },

  // Common
  'common.loading': { fr: 'Chargement...', en: 'Loading...' },
  'common.error': { fr: 'Une erreur est survenue', en: 'An error occurred' },
  'common.save': { fr: 'Enregistrer', en: 'Save' },
  'common.cancel': { fr: 'Annuler', en: 'Cancel' },
  'common.delete': { fr: 'Supprimer', en: 'Delete' },
  'common.edit': { fr: 'Modifier', en: 'Edit' },
  'common.add': { fr: 'Ajouter', en: 'Add' },
  'common.yes': { fr: 'Oui', en: 'Yes' },
  'common.no': { fr: 'Non', en: 'No' },
  'common.back': { fr: 'Retour', en: 'Back' },
  'common.close': { fr: 'Fermer', en: 'Close' },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('fr');

  const t = useCallback((key) => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry['fr'] || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'fr' ? 'en' : 'fr');
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
